import { z } from 'zod';

import { isoDatetimeToDate } from './dates';
import { fixture } from './fixtures';

export const BizyMemory = z.object({
	id: z.string(),
	category: z.string(),
	text: z.string(),
	source: z.enum(['system', 'agent', 'user']),
	createdAt: isoDatetimeToDate,
});

export type BizyMemory = z.infer<typeof BizyMemory>;

export const bizyMemoryFixture = (overrides: Partial<BizyMemory> = {}): BizyMemory => ({
	id: fixture.id(),
	category: 'preference',
	text: fixture.description('memory'),
	source: 'agent',
	createdAt: fixture.pastDate(7),
	...overrides,
});
